export const post = {
  title: 'Post a Job',
  heading: 'You do not have any existing positions',
  info: 'Start your job post by creating a position. We\'ll save it for next time, so you don\'t have to start from scratch!',
  buttonText: 'Create a Position',
  returningUser: {
    heading: 'Start your job post by choosing a position you\'ve already set up.',
    info: 'Need a different position that you haven\'t created yet?',
    buttonText: 'Create a Position',
    positions: {
      title: 'Your positions',
      subtitle: 'Best for starting with a position and going through the steps.',
      info: 'Post a new job by selecting from your existing positions. You\'ll easily be able to select from previously saved locations and schedules to post your job quickly.',
    },
    multiDayJobs: {
      title: 'Your recent job postings',
      subtitle: 'Best for tweaking details in one overview step.',
      info: 'Create a new job by leveraging a previous one. Easily change information in one review step with details you’ve already entered.',
      reUse: 'Re-use',
      workerGroups: {
        good_standing: 'Open to Wonoloers in Good Standing',
        specific: 'Open to Specific Wonoloers',
        all: 'Open to all Wonoloers'
      },
      schedule: {
        daysVary: 'Days vary (%startTime% - %endTime% • %unpaidBreakMinutes% min break)',
        daysTimeVary: 'Days and times vary',
        consistent: '%weekdays% (%startTime% - %endTime% • %unpaidBreakMinutes% min break)'
      }
    },
  },
  positionDetailsModal: {
    title: '%positionTitle% Details',
    summary: 'Position Summary',
    keyResponsibilities: 'Key Responsibilities',
    mandatoryQualifications: 'Mandatory Qualifications',
    requiredSkills: 'Required Skills',
    workContext: 'Work Context',
    dressCode: 'Dress Code',
    additionalInformation: 'Additional Information'
  }
};
